module.exports = __webpack_public_path__ + "static/img/ICON2@2x.78c1340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICON2@2x.png
// module id = HcWM
// module chunks = 1